import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Construction, BarChart3 } from 'lucide-react';

const HistoryPage = () => {
  const navigate = useNavigate();

  const handleNewAnalysis = () => {
    navigate('/analysis');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header */}
        <div className="mb-8">
          <button
            onClick={() => navigate('/')}
            className="inline-flex items-center text-gray-600 hover:text-gray-900 mb-4 transition-colors"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Home
          </button>
          
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">
            Analysis History
          </h1>
          <p className="text-lg text-gray-600">
            View your previous SEO analysis results and track improvements over time
          </p>
        </div>

        {/* Development Message */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-12 text-center">
          <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <Construction className="w-10 h-10 text-blue-600" />
          </div>
          <h3 className="text-2xl font-semibold text-gray-900 mb-4">
            Currently in Development
          </h3>
          <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
            The Analysis History feature is currently being developed. This will allow you to view your previous SEO analysis results, track improvements over time, and compare different analyses.
          </p>
          
          <div className="space-y-4">
            <button
              onClick={handleNewAnalysis}
              className="inline-flex items-center px-8 py-4 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors"
            >
              <BarChart3 className="w-5 h-5 mr-2" />
              Start New SEO Analysis
            </button>
            
            <div className="text-sm text-gray-500">
              <p>Coming soon: Save and track your SEO analysis history</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HistoryPage;
